import { LocaleService } from '@abovo/shared-angular-utils';
import { createLocalStorage } from '@abovo/shared-services';
import { DateFnsUtilityService } from '@abovo/shared-utils';
import { PreferencesState, initialPreferencesState } from '@abovo/webvis-data-access';
import { DateAdapter } from '@angular/material/core';
import { TranslateService } from '@ngx-translate/core';
import { CldrIntlService, IntlService } from '@progress/kendo-angular-intl';

export function initializeLocalization(localeService: LocaleService, translate: TranslateService, intlService: IntlService, dateAdapter: DateAdapter<Date>) {
   const localStorage = createLocalStorage<{ preferences: PreferencesState }>();
   let language: string = localStorage.get('preferences')?.language;

   if (!language) {
      language = navigator.language?.split('-')[0] || initialPreferencesState.language;
      localStorage.set('preferences', { language: language });
   }
   localeService.initLocale(language);

   translate.onLangChange.subscribe((lang) => {
      (<CldrIntlService>intlService).localeId = lang.lang;
      dateAdapter.setLocale(lang.lang === 'en' ? DateFnsUtilityService.locales.enUS : DateFnsUtilityService.locales.nl);
   });

   (<CldrIntlService>intlService).localeId = translate.getCurrentLang() || 'nl-NL';
   translate.onLangChange.subscribe((lang) => {
      (<CldrIntlService>intlService).localeId = lang.lang;
   });
}
